module.exports = __webpack_public_path__ + "static/media/icon-ranking.a0c36257.png";